module.exports = __webpack_public_path__ + "img/umfrage_ergebnis_1.be07be40.png";